module.exports = __webpack_public_path__ + "img/root001.458285c4.png";